import styled, { css } from 'styled-components'
import { black, textMuted, white, border2 } from '@/theme/colors'
import { fontMono } from '@/theme/fonts'
import { radii } from '@/theme/tokens'
import { fontSizes, text } from '@/theme/typography'

/** The card: caption and value on the left, the copy control pinned right. */
export const Card = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	width: 100%;
	background: ${white};
	border: 1px solid ${border2};
	border-radius: ${radii.inner};
	padding: 10px 10px 10px 16px;
	text-align: left;
`

/** Left column — `min-width: 0` so a long value can ellipsize instead of pushing the button out. */
export const Text = styled.div`
	min-width: 0;
`

export const Caption = styled.div`
	${text.caption}
	color: ${textMuted};
`

export const Value = styled.div<{ $variant: 'code' | 'text' }>`
	margin-top: 2px;
	color: ${black};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	${props =>
		props.$variant === 'code'
			? css`
					font-family: ${fontMono};
					font-weight: 700;
					font-size: ${fontSizes.title};
				`
			: css`
					${text.bodySm}
				`}
`
